// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1eGnL","dragIcon":"SortableItem_dragIcon__1DDaX","disabled":"SortableItem_disabled__1kO4f"};